import { Social } from '@/types/auth'

export const socialsLogin: Social[] = [
  {
    title: 'login_google',
    provider: 'google',
    color: '#4285F4',
  },
  {
    title: 'login_linkedin',
    provider: 'linkedin',
    color: '#0A66C2',
  },
  {
    title: 'login_facebook',
    provider: 'facebook',
    color: '#0866FF',
  },
  {
    title: 'login_github',
    provider: 'github',
    color: '#181717',
  },
]

export const socialsBasic: Social[] = [
  {
    title: 'google',
    provider: 'google',
    color: '#4285F4',
  },
  {
    title: 'linkedin',
    provider: 'linkedin',
    color: '#0A66C2',
  },
  {
    title: 'facebook',
    provider: 'facebook',
    color: '#0866FF',
  },
  {
    title: 'github',
    provider: 'github',
    color: '#181717',
  },
]

export const socialsRegister: Social[] = [
  {
    title: 'continue_google',
    provider: 'google',
    color: '#4285F4',
  },
  {
    title: 'continue_linkedin',
    provider: 'linkedin',
    color: '#0A66C2',
  },
  {
    title: 'continue_facebook',
    provider: 'facebook',
    color: '#0866FF',
  },
  {
    title: 'continue_github',
    provider: 'github',
    color: '#181717',
  },
]
